export default __webpack_public_path__ + "static/og-image-3b83ed1f63b1487f5bad5b86ace3b791.jpg";